<template functional>
  <div class="rounded d-inline-block pl-3 pr-3 ma-1 inverted text-center">
    <nuxt-link
      data-test-id="KeywordsLink"
      :to="`/engage/${partner}/search-dashboard?keywords=${props.keyword}`"
      class="text-decoration-none font-weight-bold"
      >{{ props.keyword }}</nuxt-link
    >
  </div>
</template>

<script>
export default {
  name: "KeywordTag",
  props: {
    keyword: { type: String, required: true },
  },
  computed: {
    partner() {
      return this.$config.partner;
    },
  },
};
</script>
